import { useKeycloak } from '../../auth/KeycloakProvider';
import { addAccessTokenToUrl } from '../global/addAccessTokenToUrl';

/**
 * Hook to get attachment URL with access_token query parameter
 * Use this in React components that need to display or download attachments
 */
export function useAttachmentUrl(url: string): string {
  const { keycloak } = useKeycloak();
  const token = keycloak?.token;
  return addAccessTokenToUrl(url, token);
}
